<template>
  <v-btn text v-on:click="goBack" class="back-arrow" color="primary">
    <v-icon>mdi-arrow-left</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "BackButton",
  props: ["defaultRouter"],
  computed: {
    from() {
      return this.$store.getters["historyStore/getRouterBefore"];
    }
  },
  methods: {
    goBack() {
      let from = { meta: {}, ...this.from };
      from.meta.notForHistory = true;
      if (this.from) {
        this.$store.dispatch("historyStore/setRouterBefore");
      }
      this.$router.push((this.from && from) || this.defaultRouter);
    }
  }
};
</script>

<style scoped></style>
